// extracted by mini-css-extract-plugin
export var attributionName = "testimonialsQuote-module--attributionName--f4dde";
export var attributionTitle = "testimonialsQuote-module--attributionTitle--45e59";
export var buttons = "testimonialsQuote-module--buttons--60811";
export var dark = "testimonialsQuote-module--dark--ad03b";
export var gradientBackground = "testimonialsQuote-module--gradientBackground--8b0a7";
export var grid = "testimonialsQuote-module--grid--d9310";
export var icon = "testimonialsQuote-module--icon--90b9c";
export var light = "testimonialsQuote-module--light--20d22";
export var logo = "testimonialsQuote-module--logo--02643";
export var quoteText = "testimonialsQuote-module--quoteText--6df85";
export var testimonialQuote = "testimonialsQuote-module--testimonialQuote--93294";
export var textWrapper = "testimonialsQuote-module--textWrapper--7fc9c";